<template>
	<div class="animated fadeIn">
		<b-row>
			<b-col class="animated fadeIn" cols="12">
				<nueva-cabecera-de-inventario />
				<c-paginate table-uri="paginate/table/reportes_inventario" caption="Levantamientos físicos de inventarios"	:fields="fields" edit-name="Levantamiento de inventario">	</c-paginate>
			</b-col>
		</b-row>
	</div>
</template>

<script>
	import _ from 'lodash'
	import nuevaCabeceraDeInventario from './nuevaCabeceraDeInventario.vue'
	export default {
		name: 'InventariosIndex',
		components: {nuevaCabeceraDeInventario},
		data: () => {
			return {
				fields: [
					{
						key: 'nombre',
						label: 'Encargado'
					},
					{
						key: 'created',
						label: 'Creación'
					},
					{
						key: 'finished',
						label: 'Cierre'
					},
					// {
					// 	key: 'comentarios'
					// },
					{
						key: 'estatus'
					},
					{
						key: 'saldo'
					},

					{
						key: '_',
						label: ''
					}
				]
			}
		}
	}
</script>
